import { __assign, __rest } from "tslib";
// TierPromotionCardSemiDumb - accepts a PapiDeviation + CTA button type
// and turns it into primitive attributes of TierPromotionCardDumb
import React from 'react';
import SubscribeButton from '../../Button/SubscribeButton';
import EditTierButton from '../../Tier/EditTierButton';
import TierPromotionCardDumb from '../TierPromotionCardDumb';
import { getTierDescription } from '../_helpers';
import SubscribeVariant from '../../Button/SubscribeButton/variants/Subscribe';
import DummySubscribedVariant from '../../Button/SubscribeButton/variants/DummySubscribed';
var TierPromotionCardSemiDumb = function (_a) {
    var deviation = _a.deviation, ctaButton = _a.ctaButton, ctaClassname = _a.ctaClassname, props = __rest(_a, ["deviation", "ctaButton", "ctaClassname"]);
    if (!deviation.tier) {
        return null;
    }
    var _b = deviation.title, title = _b === void 0 ? '' : _b, author = deviation.author, tier = deviation.tier, coverImage = deviation.coverImage;
    // Note: subscribers stats are undefined when user chooses to hide them
    // therefore DO NOT DEFAULT COUNTS TO ZERO
    var _c = tier || {}, dollarPrice = _c.dollarPrice, _d = _c.stats, _e = _d === void 0 ? {} : _d, _f = _e.subscribers, numSubscribers = _f === void 0 ? undefined : _f, state = _c.state;
    var ctaButtonNode;
    switch (ctaButton) {
        case 'subscribe':
            ctaButtonNode = (React.createElement(SubscribeButton, { className: ctaClassname, type: 'subscribe', tier: deviation }));
            break;
        case 'view':
            ctaButtonNode = (React.createElement(SubscribeButton, { className: ctaClassname, type: 'view', tier: deviation }));
            break;
        case 'view-subscribed':
            ctaButtonNode = (React.createElement(DummySubscribedVariant, { className: ctaClassname, onClick: props.onClick }));
            break;
        case 'view-subscribe':
            ctaButtonNode = (React.createElement(SubscribeVariant, { className: ctaClassname, tier: deviation }));
            break;
        case 'edit':
            ctaButtonNode = (React.createElement(EditTierButton, { className: ctaClassname, tier: deviation, view: 'promotion' }));
            break;
        case 'disabled':
            ctaButtonNode = (React.createElement(SubscribeButton, { className: ctaClassname, type: 'disabled', tier: deviation }));
            break;
        default:
    }
    return (React.createElement(TierPromotionCardDumb, __assign({ author: author, coverImage: coverImage, title: title, description: getTierDescription(deviation), numSubscribers: numSubscribers, price: dollarPrice, ctaButton: ctaButtonNode, state: state }, props)));
};
TierPromotionCardSemiDumb.displayName = 'TierPromotionCardSemiDumb';
export default TierPromotionCardSemiDumb;
//# sourceMappingURL=TierPromotionCardSemiDumb.js.map